import styled from 'styled-components'

import { Text, Colors, Spacing } from '@doordash/design-language'

export const CrumbContainer = styled.ul`
  display: flex;
  flex-direction: row;
  list-style: none;

  @media (max-width: 640px) {
    flex-direction: column;
  }
`

type BreadcrumbProps = {
  color?: string
  tag?: string
}

export const Breadcrumb = styled(Text)`
  color: ${(props: BreadcrumbProps) =>
    props.color ? props.color : Colors.SystemGrey60};
  text-decoration: none;

  &:hover {
    text-decoration: ${(props: BreadcrumbProps) =>
    props.tag ? 'underline' : 'none'};
  }
`

export const ListItemContainer = styled.li`
  display: flex;
`

export const Separator = styled.span`
  display: flex;
  align-items: center;
  color: ${Colors.SystemGrey60};
  font-weight: bold;
  line-height: 1rem;
  padding: 0 ${Spacing.XxSmall}px 0 ${Spacing.XxSmall}px;
`
